import { Col, DesignTokens, Row, Title } from "melco-ui";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MachineStatusGrid } from "../status/grid/MachineStatusGrid";
import { MachineStatusGridItem } from "../status/grid/MachineStatusGridItem";
import { machineStatusIdToName } from "../helper/status";

type DisplayMachineStatusViewGroupsAndMachinesProps = {
  viewDetail: any;
};

const { colors, spacings } = DesignTokens;

// Create a styled component based on the Badge

const DisplayWrapper = styled.div`
  margin: 15px;
`;

export const DisplayMachineStatusViewGroupsAndMachies: React.FC<
  DisplayMachineStatusViewGroupsAndMachinesProps
> = ({ viewDetail }) => {
  const { t } = useTranslation();
  //let { data: viewDetail } = useMachineStatusView(view?.id);
  //viewDetail = {"id":"VW-4","name":"V1","grouped_display":true,"group_count":2,"group_list":[{"id":"GRP-1","name":"G1","machine_count":2,"machine_list":[{"serial_number":"IG1004","name":"IG1004","last_status":"1"},{"serial_number":"IG1003","name":"IG1003","last_status":"2"}]},{"id":"GRP-2","name":"G5","machine_count":5,"machine_list":[{"serial_number":"IG1004","name":"IG1004","last_status":"3"},{"serial_number":"IG1003","name":"IG1003","last_status":"1"},{"serial_number":"IG1002","name":"IG1002","last_status":"2"},{"serial_number":"IG1005","name":"IG1005","last_status":"3"},{"serial_number":"IG1001","name":"IG1001","last_status":"1"}]}]};
  const [messages, setMessages] = useState<string[]>([]);
  const socketRef = useRef<WebSocket | null>(null);
  const [lastDataReceivedTime, setLastDataReceivedTime] = useState(Date.now());
  const [visible, setVisible] = useState(false);

  const getDeviceIds = async () => {
    let deviceIds: string[] = [];
    // Iterate through each group in the group_list
    viewDetail.group_list.forEach((group: any) => {
      // Iterate through each machine in the machine_list of the group
      group.machine_list.forEach((device: any) => {
        // Add serial_number to the list
        deviceIds.push(device.serial_number);
      });
    });

    return deviceIds;
  };

  // Effect to check inactivity condition
  useEffect(() => {
    const checkInactivity = () => {
      const currentTime = Date.now();
      if (currentTime - lastDataReceivedTime > 5 * 60000) {
        // 5 minute
        setVisible(true);
      }
    };

    const interval = setInterval(checkInactivity, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [lastDataReceivedTime]);

  useEffect(() => {
    const connect = (url: string) => {
      console.log("ws - connect");
      console.log(url);
      socketRef.current = new WebSocket(url);

      socketRef.current.onmessage = (event: any) => {
        //  alert("incoming message");
        console.log(event.data);
        //debugger;
        setMessages((prevMessages) => [...prevMessages, event.data]);
      };

      socketRef.current.onclose = () => {
        console.log(
          "ws - Socket is closed. Reconnect will be attempted in 1 second."
        );
        setTimeout(function () {
          connect(url);
        }, 1000);
      };

      socketRef.current.onerror = (err: any) => {
        console.log(
          "ws - Socket encountered error: ",
          err.message,
          "ws - Closing socket"
        );
        socketRef?.current?.close();
      };
    };

    const initialCall = async () => {
      let deviceIds = await getDeviceIds();
      if (deviceIds.length > 0) {
        fetch(
          `https://castleapi.nicecoast-f6e97df0.centralus.azurecontainerapps.io/api/iot/machines/subscribe`,
          {
            method: "POST",
            headers: {
              "x-api-key": "3a0777b2823b47c94aa4f64cc016fc34",
              "x-customer-id": "9",
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              deviceIds: deviceIds,
            }),
          }
        ).then(async (response) => {
          const result = (await response.json()) as {
            url: string;
            deviceIds: string[];
          };

          connect(result.url);
        });
      }
    };

    initialCall();
  }, []);

  // viewDetail = {
  //   id: "VW-4",
  //   name: "V1",
  //   grouped_display: false,
  //   group_count: 2,
  //   group_list: [
  //     {
  //       id: "GRP-1",
  //       name: "G1",
  //       machine_count: 2,
  //       machine_list: [
  //         {
  //           serial_number: "IG1004",
  //           name: "Machine Long Name IG1004",
  //           last_status: "1",
  //         },
  //         { serial_number: "IG1003", name: " IG1003", last_status: "2" },
  //       ],
  //     },
  //     {
  //       id: "GRP-2",
  //       name: "G5",
  //       machine_count: 5,
  //       machine_list: [
  //         { serial_number: "IG1003", name: " IG1003", last_status: "2" },
  //         { serial_number: "IG1003", name: " IG1003", last_status: "2" },
  //         { serial_number: "IG1003", name: " IG1003", last_status: "2" },
  //       ],
  //     },
  //   ],
  // };

  return (
    <>
      {viewDetail?.grouped_display ? (
        <>
          {viewDetail?.group_list && viewDetail?.group_list?.length > 0 && (
            <>
              {viewDetail?.group_list?.map((group: any) => {
                return (
                  <>
                    <DisplayWrapper>
                      {group?.machine_list?.length > 0 ? (
                        <MachineStatusGrid title={group.name}>
                          <>
                            {group?.machine_list?.map((machine: any) => {
                              return (
                                <>
                                  <MachineStatusGridItem
                                    machineName={machine.name}
                                    status={
                                      visible
                                        ? "notconnected"
                                        : machineStatusIdToName(
                                            machine?.last_status
                                          )
                                    }
                                    tooltip={
                                      visible
                                        ? t("view.popover.content")
                                        : undefined
                                    }
                                  />
                                </>
                              );
                            })}
                          </>
                        </MachineStatusGrid>
                      ) : (
                        <></>
                      )}
                    </DisplayWrapper>
                  </>
                );
              })}
            </>
          )}
        </>
      ) : (
        <>
          <DisplayWrapper>
            {viewDetail?.group_list && viewDetail?.group_list?.length > 0 && (
              <Row gutter={[spacings.middle, spacings.middle]}>
                {viewDetail?.group_list?.map((group: any) => {
                  return (
                    <>
                      {group?.machine_list?.length > 0 ? (
                        <>
                          {group?.machine_list?.map((machine: any) => {
                            return (
                              <Col xs={24} md={6} xl={6}>
                                <MachineStatusGridItem
                                  machineName={machine.name}
                                  status={
                                    visible
                                      ? "notconnected"
                                      : machineStatusIdToName(
                                          machine?.last_status
                                        )
                                  }
                                  tooltip={
                                    visible
                                      ? t("view.popover.content")
                                      : undefined
                                  }
                                />
                              </Col>
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </Row>
            )}
          </DisplayWrapper>
        </>
      )}
    </>
  );
};
